module.exports = __webpack_public_path__ + "img/电力-电缆标签.d194ad58.jpg";